import { Coords } from 'shared/types';

export function serializeLocationHeader(position: Coords | null): string {
  if (!position) return '';
  if (!position?.accuracy) return `${position.latitude},${position.longitude}`;
  return `${position.latitude},${position.longitude},${position.accuracy}`;
}
